import { FunctionComponent, useEffect, useState } from 'react';
import Banner from '@leafygreen-ui/banner';
import Markdown from '@ts-tools/markdown';
import { supportFetch } from '../../middleware/supportFetch';
import { css, cx } from '@ts-tools/emotion';

export const Alerts: FunctionComponent = () => {
  const [list, setList]: any[] = useState([]);
  const [cloud, setCloud]: any[] = useState([]);
  const [maintenance, setMaintenance]: any[] = useState([]);

  const getData = async () => {
    const res = await supportFetch.get(`/public/v1.0/alerts`)
    if (res && res.results && res.results.length) {
      setList(res.results);
    }
    if (res && res.cloud && res.cloud.length) {
      setCloud(res.cloud);
    }
    if (res && res.maintenance && res.maintenance.length) {
      setMaintenance(res.maintenance);
    }
  }

  useEffect(() => {
    getData();
    const interval = setInterval(getData, (10 * 60 * 1000));
      return () => clearInterval(interval);
  },[]);

  return <div>
  {cloud.map((item: any, i: number) => (
    <Banner key={'cloud-' + i} variant='warning' style={{ borderRadius: 0, textAlign: 'center' }}>
      <span className={'markdown-fix-alert ' + css`color: unset !important; font-size: 14px !important; font-family: "Akzidenz" !important;`}>
      Please be aware that we are tracking a known incident: "<a href={item.shortlink} target="_blank">{item.name}</a>". You can subscribe to updates on our <a href="https://status.cloud.mongodb.com" target="_blank">MongoDB Cloud Status</a> page.
      </span>
    </Banner>
  ))}
  {cloud.length <= 0 && maintenance.map((item: any, i: number) => (
    <Banner key={'cloud-' + i} variant='warning' style={{ borderRadius: 0, textAlign: 'center' }}>
      <span className={'markdown-fix-alert ' + css`color: unset !important; font-size: 14px !important; font-family: "Akzidenz" !important;`}>
      Please be aware of scheduled maintenance: "<a href={item.shortlink} target="_blank">{item.name}</a>". You can subscribe to updates on our <a href="https://status.cloud.mongodb.com" target="_blank">MongoDB Cloud Status</a> page.
      </span>
    </Banner>
  ))}
  {list.map((item: any, i: number) => (
    <Banner key={'alert-' + i} variant={item.Level__c.toLowerCase()} style={{ borderRadius: 0, textAlign: 'center' }}>
      <Markdown.Renderer
        className={'markdown-fix-alert ' + css`color: unset !important; font-size: 14px !important; font-family: "Akzidenz" !important;`} 
        markdown={item.Message__c} />
    </Banner>
  ))}
  </div> 
};
